var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C11.5821 8 8 11.5821 8 16C8 20.4179 11.5821 24 16 24C20.4179 24 24 20.4179 24 16C24 11.5821 20.4179 8 16 8ZM16 22.6429C12.3321 22.6429 9.35714 19.6679 9.35714 16C9.35714 12.3321 12.3321 9.35714 16 9.35714C19.6679 9.35714 22.6429 12.3321 22.6429 16C22.6429 19.6679 19.6679 22.6429 16 22.6429ZM14.4286 13.1429H13.5714C13.4929 13.1429 13.4286 13.2071 13.4286 13.2857V18.7143C13.4286 18.7929 13.4929 18.8571 13.5714 18.8571H14.4286C14.5071 18.8571 14.5714 18.7929 14.5714 18.7143V13.2857C14.5714 13.2071 14.5071 13.1429 14.4286 13.1429ZM18.4286 13.1429H17.5714C17.4929 13.1429 17.4286 13.2071 17.4286 13.2857V18.7143C17.4286 18.7929 17.4929 18.8571 17.5714 18.8571H18.4286C18.5071 18.8571 18.5714 18.7929 18.5714 18.7143V13.2857C18.5714 13.2071 18.5071 13.1429 18.4286 13.1429Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircle);
export default __webpack_public_path__ + "static/media/PauseCircle.4ac8021f3efd17c8c2c897838e257325.svg";
export { ForwardRef as ReactComponent };